export default "/images/alert-octagon.svg?3f421d95d21e53b10880e05fe1db8e8f";